$(document).keyup(function(e) {
  if (e.keyCode === 27) { // ESC
    closeLightbox();
  }
});

$(document).ready(function () {

  if($('.js-lightbox-trigger').length > 0){
    setTimeout(openLightbox, 1000);
  }

  $('.js-lightbox-trigger').click(function(){
    openLightbox();
  });

  if($('.ns-story-lightbox').length){
    // console.log('has story');
    $('.ns-story-lightbox').hide();
    $('body').append('<div class="lightbox-backdrop"></div>');
    $('.ns-story-lightbox').prepend('<button class="nhsnote-box__close js-nhsnote-box-close"></button>');
  }

  $('body').on('click', '.lightbox-backdrop, .nhsnote-box__close', function(){
    closeLightbox();
  });
});

function openLightbox(){
  $('body').addClass('lightbox-open');
  $('.ns-story-lightbox').fadeIn();
  $('.lightbox-backdrop').fadeIn();
}

function closeLightbox(){
  $('body').removeClass('lightbox-open');
  $('.ns-story-lightbox').fadeOut();
  $('.lightbox-backdrop').fadeOut();
}
